import React from "react";

/**
 * component svg 
 */
const NoPapers = function (props) {

    return (
        <svg version="1.1" id="no-papers" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	    viewBox="0 0 1000 1000">
            <line className="st0-no-papers" x1="790" y1="223.1" x2="790" y2="255.6"/>
            <line className="st1-no-papers" x1="790" y1="357.8" x2="790" y2="801.3"/>
            <polyline className="st0-no-papers" points="790,852.4 790,884.9 757.5,884.9 		"/>
            <line className="st2-no-papers" x1="635.6" y1="884.9" x2="303.4" y2="884.9"/>
            <polyline className="st0-no-papers" points="242.5,884.9 210,884.9 210,852.4 		"/>
            <line className="st3-no-papers" x1="210" y1="757.8" x2="210" y2="194.9"/>
            <polyline className="st0-no-papers" points="210,147.6 210,115.1 242.5,115.1 		"/>
            <polyline className="st4-no-papers" points="338.4,115.1 682,115.1 733.1,166.2 		"/>
            <polyline className="st0-no-papers" points="767,200.1 790,223.1 757.5,223.1 		"/>
            <polyline className="st0-no-papers" points="714.5,223.1 682,223.1 682,190.6 		"/>
            <line className="st0-no-papers" x1="682" y1="147.6" x2="682" y2="115.1"/>
        </svg>
    );
};

export default NoPapers;